module.exports = __webpack_public_path__ + "static/media/astrid_levelup_sentencebuilder.ff628d86.png";